import React, { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

// Reusable enquiry form. Pass menuId to auto-attach a built menu.
export default function EnquiryForm({ menuId = null, defaults = {}, onSuccess }) {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", event_date: "", occasion: defaults.occasion || "",
    guest_count: defaults.guest_count || "", message: "", company: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please enter your name and phone number");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        ...form,
        email: form.email || null,
        guest_count: parseInt(form.guest_count) || 0,
        menu_id: menuId,
      };
      await api.post("/enquiries", payload);
      toast.success("Enquiry sent! We'll be in touch shortly.");
      setForm({ name: "", phone: "", email: "", event_date: "", occasion: "", guest_count: "", message: "", company: "" });
      onSuccess && onSuccess();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-white border border-[#E5DCC9] rounded-sm px-4 py-3 text-[#1A1A1A] outline-none focus:border-[#C9A66B] focus:ring-1 focus:ring-[#C9A66B] transition-colors";

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="enquiry-form">
      {/* honeypot */}
      <input type="text" value={form.company} onChange={set("company")} name="company" tabIndex={-1} autoComplete="off"
        className="hidden" aria-hidden="true" />

      <div className="grid sm:grid-cols-2 gap-4">
        <input className={inputCls} placeholder="Your name *" value={form.name} onChange={set("name")} data-testid="enquiry-name" />
        <input className={inputCls} placeholder="Phone number *" value={form.phone} onChange={set("phone")} data-testid="enquiry-phone" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <input className={inputCls} placeholder="Email (optional)" value={form.email} onChange={set("email")} data-testid="enquiry-email" />
        <input className={inputCls} type="date" value={form.event_date} onChange={set("event_date")} data-testid="enquiry-date" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <input className={inputCls} placeholder="Occasion (e.g. Wedding)" value={form.occasion} onChange={set("occasion")} data-testid="enquiry-occasion" />
        <input className={inputCls} type="number" placeholder="Guest count" value={form.guest_count} onChange={set("guest_count")} data-testid="enquiry-guests" />
      </div>
      <textarea className={inputCls} rows={4} placeholder="Tell us about your event…" value={form.message} onChange={set("message")} data-testid="enquiry-message" />
      {menuId && <p className="text-xs text-[#B08D4F]">✓ Your built menu will be attached to this enquiry.</p>}
      <button type="submit" disabled={loading} className="btn-gold px-8 py-4 rounded-sm flex items-center gap-2 text-sm disabled:opacity-60" data-testid="enquiry-submit">
        {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
        {loading ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
}
